import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { devtools } from "zustand/middleware";

type NetworkStatusState = {
  isOnline: boolean;
};

type NetworkStatusAction = {
  setOnlineStatus: (isOnline: boolean) => void;
};

const defaultState: NetworkStatusState = {
  isOnline: false,
};

export const useNetworkStatusStore = create<
  NetworkStatusState & NetworkStatusAction
>()(
  devtools(
    immer((set) => ({
      ...defaultState,
      setOnlineStatus(isOnline) {
        set((state) => {
          state.isOnline = isOnline;
        });
      },
    })),

    {
      name: "NetworkStatusStore",
      enabled: true,
    }
  )
);
